/**
 * Pull the displayable i18n key out of a TanStack Form field error.
 *
 * With a standard-schema (Zod v4) validator, `field.state.meta.errors` entries are the schema
 * ISSUES (objects carrying `message`), not strings. Our schemas put i18n keys in those messages,
 * so what comes back is a key the caller resolves with `t()`. A plain string (a manually pushed
 * error) also works. Anything else yields `undefined`, so a field shows no error rather than
 * `[object Object]`.
 *
 * Lifted to core for the rebuilt workflows: the old modules each carry their own copy, which
 * goes when each of them is rebuilt. The type parameter keeps `t()` type-checked per caller.
 */
export function fieldErrorKey<TKey extends string>(
  errors: readonly unknown[]
): TKey | undefined {
  const first = errors[0];
  const message =
    typeof first === "string"
      ? first
      : first && typeof first === "object" && "message" in first
        ? (first as { message: unknown }).message
        : undefined;
  return typeof message === "string" ? (message as TKey) : undefined;
}
